import { createSelector } from 'reselect';

const selector = state => {
  return state.sectors.items.asMutable({ deep: true });
}

export default createSelector(
  [selector], sectors => sectors
)



// WEBPACK FOOTER //
// ./src/selectors/sectors-selector.js